<template>
  <div id="android-navbar" class="transparent-background" :class="(isCash && deliveryCode) ? 'position-absolute' : ''">
    <div v-if="withLogo" :class="isCash ? 'logo-left-mobile-android' : 'logo-left'">
      <div class="circle">
        <img :src="order.workspace.logo" class="logo-workspace">
      </div>
    </div>
    <div v-if="!isMap">
      <div v-if="showWorkspaceName" class="logo-name">
        <span>{{ isWorkspaceName }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'AndroidNavBar',
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    withLogo: {
      type: Boolean,
      default: () => false
    },
    isWorkspaceName: {
      type: String,
      default: () => ''
    },
    isMap: {
      type: Boolean,
      default: () => false
    },
    isCash: {
      type: Boolean,
      default: false
    },
    deliveryCode: {
      type: String,
      default: ''
    },
    isCustomLogo: {
      type: Boolean,
      default: false
    },
    showWorkspaceName: {
      type: Boolean,
      default: true
    }
  }
}
</script>
